module.exports = __webpack_public_path__ + "images/questions/qa_balloon_01_7528eb3f028f3063a0d93ff0de2ef960.png";